var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAttachment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41667 4.99992V14.5833C8.41667 16.4249 6.925 17.9166 5.08333 17.9166C3.24167 17.9166 1.75 16.4249 1.75 14.5833V4.16658C1.75 3.01659 2.68333 2.08325 3.83333 2.08325C4.98333 2.08325 5.91667 3.01659 5.91667 4.16658V12.9166C5.91667 13.3749 5.54167 13.7499 5.08333 13.7499C4.625 13.7499 4.25 13.3749 4.25 12.9166V4.99992H3V12.9166C3 14.0666 3.93333 14.9999 5.08333 14.9999C6.23333 14.9999 7.16667 14.0666 7.16667 12.9166V4.16658C7.16667 2.32492 5.675 0.833252 3.83333 0.833252C1.99167 0.833252 0.5 2.32492 0.5 4.16658V14.5833C0.5 17.1166 2.55 19.1666 5.08333 19.1666C7.61667 19.1666 9.66667 17.1166 9.66667 14.5833V4.99992H8.41667Z",
    fill: "#AFAFAE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAttachment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_attachment.c8774332fefb25801f9781ac6eeab09d.svg";